import { InjectionToken } from '@angular/core';
import { BookingsDataService } from '../repositories/bookings-data.service';

export const BOOKINGS_DATA_SERVICE = new InjectionToken<BookingsDataService>(
  'BOOKINGS_DATA_SERVICE'
);
